<template>
  <div class="timeline">
    <div class="timeline-base">
      <div class="time" v-for="time in times" v-bind:key="time.time">
        <span :style="'color:' + fontColor">{{time}}</span>
      </div>
    </div>
    <div class="hide-area" :style="{backgroundColor: bodyColor}"/>
  </div>
</template>

<script>
export default {
  name: 'TimeLine',
  props: {
    startTime: '',
    endTime: '',
    fontColor: '',
    bodyColor: ''
  },
  data () {
    return {
      times: []
    }
  },
  watch: {
    startTime: function (val) {
      this.startTime = val
    },
    endTime: function (val) {
      this.endTime = val
      this.setTime()
    }
  },
  mounted () {
    this.setTime()
  },
  methods: {
    setTime: function () {
      // 呼び出し確認
      this.times = []
      for (let i = this.startTime; i <= this.endTime; i++) {
        let t = i
        if (t >= 24) {
          t -= 24
        }
        this.times.push(t + ':00')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/components/parts/TimeLine";
</style>



// WEBPACK FOOTER //
// src/components/parts/TimeLine.vue